export const formatPhoneNumber = (str: string) => {
  const cleaned = `${str}`.replace(/\D/g, '');
  const fullMatch = cleaned.match(/(\d{1})?(\d{3})(\d{3})(\d{4})(\d{0,10})?$/);

  if (fullMatch) {
    const formattedNumber: string[] = [];

    if (fullMatch[2]) {
      formattedNumber.push('+1');
      formattedNumber.push(`(${fullMatch[2]})`);
    }

    formattedNumber.push(`${fullMatch[3]}-${fullMatch[4]}`);

    if (fullMatch[5]) {
      formattedNumber.push(`ext. ${fullMatch[5]}`);
    }

    return formattedNumber.join(' ');
  }

  const partialMatch = cleaned.match(/(\d{3})(\d{4})$/);

  if (partialMatch) {
    return [partialMatch[1], partialMatch[2]].join('-');
  }

  return str;
};
